import { Component, EventEmitter, Output, ElementRef, ViewChildren, QueryList, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { HeaderComponent } from '../components/header/header.component';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TEU_LOGO_SVG, TEU_LOGO_SVG_BLUE } from '../assets/constants';
import { SubheaderComponent } from '../components/subheader/subheader.component';

@Component({
  selector: 'app-otp-verification',
  standalone: true,
  imports: [CommonModule, FormsModule, HeaderComponent, SidebarComponent, SubheaderComponent],
  templateUrl: './otp-verification.component.html',
  styleUrl: './otp-verification.component.css'
})
export class OtpVerificationComponent implements OnInit, OnDestroy {
  @Output() backToRegistration = new EventEmitter<void>();
  @Output() navigatePersonalData = new EventEmitter<void>();
  teuLogo: SafeHtml;
  teuLogoBlue: SafeHtml;

  otpDigits: string[] = ['', '', '', '', '', ''];
  
  // Propiedades para el contador
  timeRemaining: number = 1 * 60; // 12 minutos en segundos
  timerInterval: any;
  canResend: boolean = false;

  @ViewChildren('otpInput') inputs!: QueryList<ElementRef<HTMLInputElement>>;

  constructor(private sanitizer: DomSanitizer, private router: Router) {
    this.teuLogo = this.sanitizer.bypassSecurityTrustHtml(TEU_LOGO_SVG);
    this.teuLogoBlue = this.sanitizer.bypassSecurityTrustHtml(TEU_LOGO_SVG_BLUE);
  }

  ngOnInit() {
    this.startTimer();
  }

  ngOnDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  startTimer() {
    this.canResend = false;
    this.timeRemaining = 1 * 60; // 12 minutos
    
    this.timerInterval = setInterval(() => {
      this.timeRemaining--;
      
      if (this.timeRemaining <= 0) {
        this.canResend = true;
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  get formattedTime(): string {
    if (this.timeRemaining <= 0) {
      return '00:00';
    }
    
    const minutes = Math.floor(this.timeRemaining / 60);
    const seconds = this.timeRemaining % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  resendCode() {
    if (this.canResend) {
      // Aquí puedes agregar la lógica para reenviar el código
      console.log('Reenviando código...');
      // Reiniciar el timer
      this.startTimer();
      // Limpiar los campos OTP
      this.otpDigits = ['', '', '', '', '', ''];
      // Enfocar el primer input
      setTimeout(() => {
        this.inputs.first?.nativeElement.focus();
      }, 100);
    }
  }

  onOtpInput(index: number) {
    // Forzar solo 1 dígito numérico
    this.otpDigits[index] = (this.otpDigits[index] ?? '').replace(/\D/g, '').slice(0, 1);

    // Si escribió un dígito, pasar al siguiente
    if (this.otpDigits[index] && index < this.otpDigits.length - 1) {
      this.inputs.get(index + 1)?.nativeElement.focus();
    }
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const key = event.key;

    // Permitir navegación y edición básica
    const controlKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'];
    if (!/[0-9]/.test(key) && !controlKeys.includes(key)) {
      event.preventDefault();
      return;
    }

    // Backspace en vacío -> ir al anterior
    if (key === 'Backspace' && !this.otpDigits[index] && index > 0) {
      event.preventDefault();
      this.inputs.get(index - 1)?.nativeElement.focus();
      this.otpDigits[index - 1] = '';
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const data = (event.clipboardData?.getData('text') || '').replace(/\D/g, '').slice(0, 6);
    data.split('').forEach((ch, i) => (this.otpDigits[i] = ch));
    // Enfocar el siguiente vacío
    const next = Math.min(data.length, this.otpDigits.length - 1);
    this.inputs.get(next)?.nativeElement.focus();
  }

  verifyOtp(): void {
    const otp = this.otpDigits.join('');
    if (otp.length === 6) this.router.navigate(['/personal-data']);
    else alert('Por favor, completa todos los dígitos');
  }

  goBack(): void {
    this.router.navigate(['/registration']);
  }

  onVerify(): void {
    // Lógica de verificación
    this.router.navigate(['/personal-data']);
  }

  trackByIndex(index: number) { return index; }
}